// import PropTypes from 'prop-types'
// import React, { Component } from 'react'

import Loader from '../../LoadingInfo'

// export default class Loader extends Component {
//
//   static propTypes = {
//
//   }
//
//   render() {
//     return (
//       <div>{this.props.children}</div>
//     )
//   }
//
// }

export { Loader as default }



// WEBPACK FOOTER //
// ./src/shared/components/Loader.js